export default [
  {
    path: '/manajemen-user',
    name: 'manajemen-user',
    component: () => import('@/views/dashboard/user/users-list/UsersList.vue'),
    meta: {
      requireAuth: true,
    },
  },
];